import { detailsGrid, detailsSection } from "./detailsModal";
import {
    buildFriendlyMemoryRecallDescription,
    buildFriendlyMemoryRecallTitle,
    buildMemorySettingsHref,
    buildMessageMemoryRecallBadgeLabel,
    normalizeMessageMemoryRecallPayload
} from "./messageMemoryRecall.cjs";

const MEMORY_RECALL_MODAL_ID = 'growtypeChatMessageMemoryRecallModal';
const MEMORY_RECALL_USER_MODAL_ID = 'growtypeChatMessageMemoryRecallUserModal';
const SETTINGS_MODAL_ID = 'growtypeChatSettingsModal';
const MEMORY_SETTINGS_TAB_TARGET = '#memories-content';
const DARK_MODAL_CLASS = 'growtype-chat-modal-dark';
const TARGET_MEMORY_SEARCH_PARAM = 'gt_memory_id';

function shouldShowDetailedMemoryRecall() {
    return growtype_chat_ajax?.show_response_memory_details === true
        || growtype_chat_ajax?.show_response_memory_details === '1';
}

function ensureDetailedModal() {
    let modal = document.getElementById(MEMORY_RECALL_MODAL_ID);

    if (modal) {
        modal.classList.remove(DARK_MODAL_CLASS);
        return jQuery(modal);
    }

    jQuery('body').append(`
        <div class="modal fade" id="${MEMORY_RECALL_MODAL_ID}" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Memory used in this reply</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="growtype-chat-message-memory-recall-body"></div>
                    </div>
                </div>
            </div>
        </div>
    `);

    return jQuery(`#${MEMORY_RECALL_MODAL_ID}`);
}

function ensureUserModal() {
    let modal = document.getElementById(MEMORY_RECALL_USER_MODAL_ID);

    if (modal) {
        modal.classList.add(DARK_MODAL_CLASS);
        return jQuery(modal);
    }

    jQuery('body').append(`
        <div class="modal fade ${DARK_MODAL_CLASS}" id="${MEMORY_RECALL_USER_MODAL_ID}" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header" style="border-bottom:0;padding-bottom:8px;">
                        <div>
                            <h5 class="modal-title">Memory used in this reply</h5>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body" style="padding-top:8px;">
                        <div class="growtype-chat-message-memory-recall-user-body"></div>
                    </div>
                </div>
            </div>
        </div>
    `);

    return jQuery(`#${MEMORY_RECALL_USER_MODAL_ID}`);
}

function parseMemoryRecall($trigger) {
    const raw = $trigger.closest('.g-chatform-message-memory-recall').find('.g-chatform-message-memory-recall-data').first().text().trim();

    if (!raw) {
        return null;
    }

    try {
        return normalizeMessageMemoryRecallPayload(JSON.parse(raw));
    } catch (error) {
        console.error('[message-memory-recall] invalid payload', error);
        return null;
    }
}

function openMemorySettingsFromModal(href, memoryId = '') {
    const $settingsModal = jQuery(`#${SETTINGS_MODAL_ID}`);
    const normalizedMemoryId = String(memoryId || '').trim();
    const targetUrl = new URL(href, window.location.origin);
    const currentUrl = new URL(window.location.href);
    const comparableCurrentUrl = new URL(currentUrl.toString());
    comparableCurrentUrl.searchParams.delete(TARGET_MEMORY_SEARCH_PARAM);
    const comparableTargetUrl = new URL(targetUrl.toString());
    comparableTargetUrl.searchParams.delete(TARGET_MEMORY_SEARCH_PARAM);

    if (normalizedMemoryId !== '') {
        targetUrl.searchParams.set(TARGET_MEMORY_SEARCH_PARAM, normalizedMemoryId);
    }

    if (!$settingsModal.length || typeof window === 'undefined') {
        window.location.href = targetUrl.toString();
        return;
    }

    const isSamePage = comparableTargetUrl.origin === comparableCurrentUrl.origin
        && comparableTargetUrl.pathname === comparableCurrentUrl.pathname
        && comparableTargetUrl.search === comparableCurrentUrl.search;

    if (!isSamePage) {
        window.location.href = targetUrl.toString();
        return;
    }

    window.history.replaceState({}, document.title, targetUrl.toString());

    const showTab = () => {
        const $tabButton = $settingsModal.find(`[data-bs-target="${MEMORY_SETTINGS_TAB_TARGET}"]`).first();

        if (!$tabButton.length) {
            return;
        }

        if (typeof bootstrap !== 'undefined' && bootstrap?.Tab) {
            bootstrap.Tab.getOrCreateInstance($tabButton[0]).show();
        } else {
            $tabButton.trigger('click');
        }
    };

    const $userModal = ensureUserModal();
    $userModal.modal('hide');
    $settingsModal.data('targetMemoryId', normalizedMemoryId);

    $settingsModal.one('shown.bs.modal.memoryRecallOpen', function () {
        showTab();
    });

    $settingsModal.modal('show');
}

function renderDetailedMemoryRecall(memoryRecall) {
    const badgeLabel = buildMessageMemoryRecallBadgeLabel(memoryRecall);
    const selectionDetails = Array.isArray(memoryRecall.selection) ? memoryRecall.selection : [];
    const sections = [
        detailsGrid('Memory usage', [
            ['Used for response', memoryRecall.used_for_response ? 'yes' : 'no'],
            ['Source', memoryRecall.source],
            ['Memories used', memoryRecall.count],
        ]),
        detailsSection('Recalled memories', memoryRecall.items),
    ];

    if (selectionDetails.length > 0) {
        const selectionHtml = selectionDetails.map((item, index) => {
            const details = [
                ['Memory', item.text],
                ['Type', item.memory_type_label || item.category || 'memory'],
                ['Stability', item.stability_label || ''],
                ['Confidence', item.confidence_label || ''],
                ['Freshness', item.freshness_label || ''],
                ['Why saved', item.why_saved || ''],
                ['Why used', item.why_used || ''],
                ['Status', item.status_label || 'active'],
            ].filter((row) => row[1]);

            return `
                <div style="padding:14px 16px;border:1px solid #e7ecf3;border-radius:14px;background:#fafcff;">
                    <div style="font-weight:600;margin-bottom:10px;">Memory ${index + 1}</div>
                    ${detailsGrid('', details)}
                </div>
            `;
        }).join('');

        sections.push(`
            <div class="growtype-chat-details-section">
                <h6 class="growtype-chat-details-section-title">Why these memories were selected</h6>
                <div style="display:flex;flex-direction:column;gap:12px;">${selectionHtml}</div>
            </div>
        `);
    }

    return `
        <div class="growtype-chat-message-memory-recall-details" style="display:flex;flex-direction:column;gap:18px;">
            <p style="margin:0;color:#666;">${badgeLabel}. This assistant reply was generated with these recalled memories in its prompt context.</p>
            ${sections.join('')}
        </div>
    `;
}

function renderFriendlyMemoryRecall(memoryRecall) {
    const title = buildFriendlyMemoryRecallTitle(memoryRecall);
    const description = buildFriendlyMemoryRecallDescription(memoryRecall);
    const memorySettingsHref = buildMemorySettingsHref(window.location.href);
    const selectionDetails = Array.isArray(memoryRecall.selection) ? memoryRecall.selection : [];
    const memoryCards = (selectionDetails.length > 0 ? selectionDetails : memoryRecall.items.map((text) => ({ text })))
        .map((item, index) => {
            const memoryText = String(item.text || '').trim();
            const whyUsed = String(item.why_used || '')
                .replace(/^Why used:\s*/i, '')
                .trim();

            return `
                <div class="growtype-chat-message-memory-recall-exact-memory" style="flex-direction:column;gap:8px;">
                    <div class="growtype-chat-message-memory-recall-exact-memory-header">
                        <div class="growtype-chat-message-memory-recall-exact-memory-heading">
                            <span class="growtype-chat-message-memory-recall-exact-memory-index">${index + 1}</span>
                            <span class="growtype-chat-message-memory-recall-exact-memory-label">Exact memory used</span>
                        </div>
                        <a
                            href="${memorySettingsHref}"
                            class="btn btn-primary growtype-chat-message-memory-recall-edit-memories"
                            data-memory-id="${item.id || ''}"
                            style="border-radius:999px;padding:5px 10px;font-size:11px;font-weight:600;line-height:1.1;min-height:auto;min-width:initial;"
                        >
                            Edit
                        </a>
                    </div>
                    <div class="growtype-chat-message-memory-recall-exact-memory-text">${memoryText}</div>
                    ${whyUsed !== ''
                        ? `<div class="growtype-chat-message-memory-recall-exact-memory-reason">Used because ${whyUsed.charAt(0).toLowerCase()}${whyUsed.slice(1)}</div>`
                        : ''
                    }
                </div>
            `;
        })
        .join('');

    const detailsButton = shouldShowDetailedMemoryRecall()
        ? `
            <button
                type="button"
                class="btn btn-secondary growtype-chat-message-memory-recall-open-details"
                style="border-radius:999px;padding:10px 14px;font-size:13px;font-weight:600;"
            >
                Show detailed memory info
            </button>
        `
        : '';

    return `
        <div class="growtype-chat-message-memory-recall-friendly">
            <div class="growtype-chat-message-memory-recall-friendly-intro">
                <div class="growtype-chat-message-memory-recall-friendly-title">
                    <i class="fa-solid fa-brain"></i>
                    <span>${title}</span>
                </div>
                <p class="growtype-chat-message-memory-recall-friendly-description">${description}</p>
            </div>
            <div class="growtype-chat-message-memory-recall-exact-memory-list">${memoryCards}</div>
            ${detailsButton !== '' ? `<div style="padding-top:4px;">${detailsButton}</div>` : ''}
        </div>
    `;
}

export function initMessageMemoryRecall() {
    jQuery(document)
        .off('click.growtypeChatMessageMemoryRecall', '.g-chatform-message-memory-recall-trigger')
        .on('click.growtypeChatMessageMemoryRecall', '.g-chatform-message-memory-recall-trigger', function (event) {
            event.preventDefault();

            const $trigger = jQuery(this);
            const memoryRecall = parseMemoryRecall($trigger);

            if (!memoryRecall) {
                return;
            }

            const $modal = ensureUserModal();
            $modal.data('memoryRecallPayload', memoryRecall);
            $modal.find('.growtype-chat-message-memory-recall-user-body').html(renderFriendlyMemoryRecall(memoryRecall));
            $modal.modal('show');
        });

    jQuery(document)
        .off('click.growtypeChatMessageMemoryRecallDetails', '.growtype-chat-message-memory-recall-open-details')
        .on('click.growtypeChatMessageMemoryRecallDetails', '.growtype-chat-message-memory-recall-open-details', function (event) {
            event.preventDefault();

            const $userModal = ensureUserModal();
            const memoryRecall = $userModal.data('memoryRecallPayload');

            if (!memoryRecall) {
                return;
            }

            const $modal = ensureDetailedModal();
            $modal.find('.growtype-chat-message-memory-recall-body').html(renderDetailedMemoryRecall(memoryRecall));
            $userModal.modal('hide');
            $modal.modal('show');
        });

    jQuery(document)
        .off('click.growtypeChatMessageMemoryRecallEdit', '.growtype-chat-message-memory-recall-edit-memories')
        .on('click.growtypeChatMessageMemoryRecallEdit', '.growtype-chat-message-memory-recall-edit-memories', function (event) {
            const href = jQuery(this).attr('href');
            const memoryId = jQuery(this).attr('data-memory-id') || '';

            if (!href) {
                return;
            }

            event.preventDefault();
            openMemorySettingsFromModal(href, memoryId);
        });
}
